import CoreFeaturedMedia from './CoreFeaturedMedia';

export { type CoreFeaturedMediaProps } from './CoreFeaturedMedia';
export default CoreFeaturedMedia;
